var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmergencia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "120px",
    viewBox: "0 0 100 120",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "il-emergencia") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 100,
    height: 120
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "APP-benefici\\xE1rio-[SYMPTOM-CHECKER]",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Resultado-|-Emergencia-[SYMPTOMCHECKER]",
    transform: "translate(-228.000000, -96.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "il-emergencia",
    transform: "translate(228.000000, 96.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ilustra",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CCCCCC",
    fillRule: "nonzero",
    x: 17,
    y: 109,
    width: 46,
    height: 52
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    fill: "#2F2E41",
    fillRule: "evenodd",
    cx: 45.5,
    cy: 17.5,
    r: 17.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#B96642",
    fillRule: "nonzero",
    cx: 45,
    cy: 26,
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,48 L36,46.8333305 C37.8620381,42.3721328 38.6058413,38.0761934 37.8627432,34 L52.0196075,34 C51.9875248,37.1297132 53.4795396,42.543538 55,48 Z",
    id: "Path",
    fill: "#B96642",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F7B500",
    fillRule: "nonzero",
    points: "25 121 29.4150401 45.3811933 36.9017819 43.285895 45.3481118 45.1905967 53.7944418 41 59.1694949 42.9051233 68 117.95214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7403131,172 L3,165.355071 C11.5459932,136.712341 26.9420091,71.1861792 21.9723826,47.8347834 L37,41 L31.7403131,172 Z",
    id: "Path",
    fill: "#FDFDFD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8749979,90 L7,83.1504421 L16.2744555,55.5867597 C17.3088566,52.7425268 19.2901373,50.3544648 21.8757478,48.8354531 L25,47 L23.1249979,74.7787519 L17.8749979,90 Z",
    id: "Path",
    fill: "#FDFDFD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93,166.776241 C83.8228798,172.092412 60.8831738,175.055855 50.8108527,171.343004 C50.0696873,145.405765 48.6161459,72.0390625 53.2813872,41 L70.0050123,47.8501433 L68.4846827,68.4005732 C60.4894288,85.9803477 83.7059133,147.210822 93,166.776241 Z",
    id: "Path",
    fill: "#FDFDFD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FDFDFD",
    fillRule: "nonzero",
    points: "90.8637507 86 80.6362493 82.5587737 67 66.8821704 69.2729179 47 92 79.1175475"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0698193,100.66314 C59.4139375,102.277371 60.9150811,103.289527 62.4260434,102.926095 L71,100.850402 L69.760826,95 L61.1866914,97.0752996 C59.675465,97.4413475 58.7278003,99.0475271 59.0698235,100.66314 L59.0698193,100.66314 Z",
    id: "Path",
    fill: "#B96642",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9375076,18 C48.0186039,15.5491346 42.172862,15.3717864 36.4062595,17.6538481 L34,9 L56,9 L53.9375076,18 Z",
    id: "Path",
    fill: "#2F2E41",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,95 L71.8749979,104 C80.0746686,101.713057 87.1809669,94.5033152 94,86 L92.1249979,80 L80.5,83 L67,95 Z",
    id: "Path",
    fill: "#FDFDFD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,76 L62.4285714,76 C62.4285714,54.5017942 57.8523994,39.52 53.3928593,39.52 L53,38 C56.9993438,38 59.5490918,44.2352935 60.983746,49.4662395 C62.9288525,56.5576576 64,65.9808374 64,76 Z",
    id: "Path",
    fill: "#3F3D56",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5172579,70 L27,70 C27,50.2617183 31.4489336,38 38,38 L37.6206876,39.5238095 C33.0893527,39.5238095 28.5172579,48.9473593 28.5172579,70 Z",
    id: "Path",
    fill: "#3F3D56",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#3F3D56",
    fillRule: "nonzero",
    cx: 63,
    cy: 76,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5555556,80 L21,80 C21,74.4859882 24.1401629,70 28,70 L28,71.5384615 C24.9978858,71.5384615 22.5555556,75.3342856 22.5555556,80 Z",
    id: "Path",
    fill: "#3F3D56",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,80 L33.4444444,80 C33.4444444,75.3342915 31.0021142,71.5384723 28,71.5384723 L28,70 C31.8598371,70 35,74.4859952 35,80 Z",
    id: "Path",
    fill: "#3F3D56",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#3F3D56",
    fillRule: "nonzero",
    cx: 33.5,
    cy: 79.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#3F3D56",
    fillRule: "nonzero",
    cx: 21.5,
    cy: 79.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#8FD16A",
    fillRule: "nonzero",
    points: "3 66 12.4350373 67.7186877 34 99 22.5433782 96.2499289"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.786877278,65 C0.495349385,65.0044849 0.229363161,65.1709476 0.0929035545,65.4343108 C-0.0435560517,65.697674 -0.0288154784,66.0161084 0.131362578,66.2651249 L20.1993817,97.3877429 C20.3113643,97.5617335 20.484337,97.6852279 20.6827003,97.7328098 L30.0197542,99.9782724 C30.3420596,100.055812 30.6777143,99.9217247 30.8631679,99.6413452 C31.0486216,99.3609657 31.0452952,98.9926201 30.8548096,98.7157876 L8.82135869,66.6930233 C8.70068155,66.5168214 8.51643278,66.3968757 8.3091907,66.3596026 L0.937385286,65.0138989 C0.887708794,65.0047861 0.837347262,65 0.786877278,65 Z",
    id: "Path",
    fill: "#3F3D56",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,86.9551234 L13.5622843,93 L22.435113,92.05995 C23.9990807,91.8942818 25.1410967,90.4067896 24.9858772,88.7375431 C24.8306577,87.0682966 23.4369812,85.8494055 21.8730135,86.0150735 L13,86.9551234 Z",
    id: "Path",
    fill: "#B96642",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,86.740354 C6.0272813,90.7542599 9.34696536,93.9953514 13.4356835,94 L14.9196574,94 L16,85.1614089 L7.05490396,82 L6,86.740354 Z",
    id: "Path",
    fill: "#FDFDFD",
    fillRule: "nonzero"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmergencia);
export default __webpack_public_path__ + "static/media/emergencia.2e43ada2.svg";
export { ForwardRef as ReactComponent };